import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../../components/accordion'
import { Availability } from '../../availability'

export const AvailabilityPanel = ({ isLocked, isReadOnly, ...props }) => (
  <AccordionPanel
    titleId="availability-label"
    title={I18n.t('publisher.event_types.availability.availability')}
    subheader={<Summary />}
    {...props}
  >
    <Availability
      isLocked={isLocked}
      isReadOnly={isReadOnly}
    />
  </AccordionPanel>
)
